import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import Login from "./routes/Login";
import Home from "./routes/Home";
import Main from "./routes/Main";
import GameList from "./routes/GameList";

import {ethers} from "ethers"
import Web3Modal from "web3modal"
import WalletConnectProvider from '@walletconnect/web3-provider'
import { useEffect, useCallback, useReducer } from 'react'
import {Button, Container, Nav, Navbar} from "react-bootstrap";
require('dotenv').config()

const INFURA_ID = process.env.INFURA_ID
const busdAddress = '0x78867BbEeF44f2326bF8DDd1941a4439382EF2A7'
const busdAbi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]
const spiderxAddress = '0xB5beA272A4f0156495eDCb91440d10b3d16cE6bD'
const spiderxAbi =
  [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "Bet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "Deposit",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "winner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "looser",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "summ",
          "type": "uint256"
        }
      ],
      "name": "Payments",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "Withdraw",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "GetContractTokenBalance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "GetPoolBalance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "balance",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "GetUserTokenBalance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "balances",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "betTokens",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "bets",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "deposit",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "winner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "looser",
          "type": "address"
        }
      ],
      "name": "gameResult",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "withdraw",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ]

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      rpc: {
        97: 'https://data-seed-prebsc-1-s1.binance.org:8545/'
      },
      infuraId: INFURA_ID
    }
  }
}
let web3Modal: Web3Modal

if (typeof window !== 'undefined') {
  web3Modal = new Web3Modal({
    cacheProvider: true,
    providerOptions, // required
  })
}

type StateType = {
  totalPool?: any
  tokenContract?: any
  projectContract?: any
  provider?: any
  signer?: any
  web3Provider?: any
  address?: any
  balance?: any
  chainId?: any
}

type ActionType =
    | {
  type: 'SET_WEB3_PROVIDER'
  totalPool?: StateType['totalPool']
  tokenContract?: StateType['tokenContract']
  projectContract?: StateType['projectContract']
  provider?: StateType['provider']
  signer?: StateType['signer']
  web3Provider?: StateType['web3Provider']
  address?: StateType['address']
  balance?: StateType['balance']
  chainId?: StateType['chainId']
}
    | {
  type: 'SET_TOTAL_POOL'
  totalPool?: StateType['totalPool']
}
    | {
  type: 'SET_TOKEN_CONTRACT'
  tokenContract?: StateType['tokenContract']
}
    | {
  type: 'SET_PROJECT_CONTRACT'
  projectContract?: StateType['projectContract']
}
    | {
  type: 'SET_SIGNER'
  signer?: StateType['signer']
}
    | {
  type: 'SET_ADDRESS'
  address?: StateType['address']
}
    | {
  type: 'SET_BALANCE'
  balance?: StateType['balance']
}
    | {
  type: 'SET_CHAIN_ID'
  chainId?: StateType['chainId']
}
    | {
  type: 'RESET_WEB3_PROVIDER'
}

const initialState: StateType = {
  totalPool: null,
  tokenContract: null,
  projectContract: null,
  provider: null,
  signer: null,
  web3Provider: null,
  address: null,
  balance: null,
  chainId: null,
}

function reducer(state: StateType, action: ActionType): StateType {
  switch (action.type) {
    case 'SET_WEB3_PROVIDER':
      return {
        ...state,
        provider: action.provider,
        totalPool: action.totalPool,
        tokenContract: action.tokenContract,
        projectContract: action.projectContract,
        signer: action.signer,
        web3Provider: action.web3Provider,
        address: action.address,
        balance: action.balance,
        chainId: action.chainId,
      }
    case 'SET_TOTAL_POOL':
      return {
        ...state,
        address: action.totalPool,
      }
    case 'SET_ADDRESS':
      return {
        ...state,
        address: action.address,
      }
    case 'SET_TOKEN_CONTRACT':
      return {
        ...state,
        tokenContract: action.tokenContract,
      }
    case 'SET_PROJECT_CONTRACT':
      return {
        ...state,
        projectContract: action.projectContract,
      }
    case 'SET_SIGNER':
      return {
        ...state,
        signer: action.signer,
      }
    case 'SET_BALANCE':
      return {
        ...state,
        balance: action.balance,
      }
    case 'SET_CHAIN_ID':
      return {
        ...state,
        chainId: action.chainId,
      }
    case 'RESET_WEB3_PROVIDER':
      return initialState
    default:
      throw new Error()
  }
}

export const App = (): JSX.Element => {

  const [state, dispatch] = useReducer(reducer, initialState)
  const { provider, web3Provider, address, balance, tokenContract, projectContract, totalPool } = state

  const connect = useCallback(async function () {
    const provider = await web3Modal.connect()
    const web3Provider = new ethers.providers.Web3Provider(provider)
    const signer = web3Provider.getSigner()
    const address = await signer.getAddress()
    const network = await web3Provider.getNetwork()
    const spiderxContract = new ethers.Contract(spiderxAddress, spiderxAbi, signer)
    const totalPool = ethers.utils.formatEther(await spiderxContract.balances(address)).split('.')[0]
    console.log("totalPool: ", totalPool)
    const busdContract = new ethers.Contract(busdAddress, busdAbi, signer)
    const walletBalance = ethers.utils.formatEther(await busdContract.balanceOf(address)).split('.')[0]

    dispatch({
      type: 'SET_WEB3_PROVIDER',
      totalPool: totalPool,
      tokenContract: busdContract,
      projectContract: spiderxContract,
      provider,
      signer: signer,
      web3Provider,
      address: address,
      balance: walletBalance,
      chainId: network.chainId
    })
  }, [])

  const disconnect = useCallback(
      async function () {
        await web3Modal.clearCachedProvider()
        if (provider?.disconnect && typeof provider.disconnect === 'function') {
          await provider.disconnect()
        }
        dispatch({
          type: 'RESET_WEB3_PROVIDER',
        })
      },
      [provider]
  )

  const deposit = async () => {
    const amount = "5000000000000000000" //$5

    async function subscribeEvent() {
      tokenContract.on('Approval', (from: string, to: string, value: string) => {
        if (from == address && to == spiderxAddress && parseInt(ethers.utils.hexValue(value)).toString() == amount) {
          console.log('approved')
          getAllowance().then(() => {
            projectContract.deposit(amount).then(() => {
              console.log('deposit')
              tokenContract.off('Approval', address)
            })
          })
        }
      })
    }

    async function getApprove(){
      await tokenContract.approve(spiderxAddress, amount)
    }

    async function getAllowance(){
      const result = await tokenContract.allowance(address, spiderxAddress)
      console.log(ethers.utils.formatEther(result))
    }

    await subscribeEvent()
    await getApprove()

    // await tokenContract.transfer(spiderxAddress, amount);
  }

  const bet = async () => {
    const amount = "1000000000000000000" //$1
    projectContract.betTokens(amount)
  }

  const withdraw = async () => {
    const amount = parseInt(ethers.utils.hexValue(await projectContract.balances(address))).toString()
    projectContract.withdraw(amount)
  }

  // Auto connect to the cached provider
  useEffect(() => {
    if (web3Modal.cachedProvider) {
      connect().then()
    }
  }, [connect])


  useEffect(() => {
    if (provider?.on) {
      const handleAccountsChanged = (accounts: string[]) => {
        dispatch({
          type: 'SET_ADDRESS',
          address: accounts[0],
        })
      }

      const handleChainChanged = (accounts: string[]) => {
        dispatch({
          type: 'SET_ADDRESS',
          address: accounts[0],
        })
      }

      const handleDisconnect = () => {
        disconnect().then()
      }

      provider.on('accountsChanged', handleAccountsChanged)
      provider.on('chainChanged', handleChainChanged)
      provider.on('disconnect', handleDisconnect)

      // Subscription Cleanup
      return () => {
        if (provider.removeListener) {
          provider.removeListener('accountsChanged', handleAccountsChanged)
          provider.removeListener('chainChanged', handleChainChanged)
          provider.removeListener('disconnect', handleDisconnect)
        }
      }
    }
  }, [provider, disconnect])

  return (
    <div className="container">
      <Navbar bg="light" expand='md' className="mb-3">
        <Container fluid>
          <Navbar.Brand href="#">Logo</Navbar.Brand>
          <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-md`} />
          <Nav className="grid" activeKey="/link">
            {web3Provider ? (
                <div className="grid">
                  <div className="grid">
                    <p className="chainItem">player: {address}</p>
                    <p className="chainItem">balance: {balance.toString()} BUSD</p>
                    <p className="chainItem">total pool: {totalPool} BUSD</p>
                  </div>
                  <Nav.Item className="grid">
                    <Button className="chainItem button" onClick={disconnect}>Disconnect</Button>
                    <Button className="chainItem" onClick={deposit}>Deposit</Button>
                    {(totalPool > 0) ? (
                        <>
                          <Button className="chainItem" onClick={withdraw}>Withdraw</Button>
                          <Button className="chainItem" onClick={bet}>Bet</Button>
                        </>
                    ) : (
                        <></>
                    )}
                  </Nav.Item>
                </div>
            ) : (
                <div>
                  <Nav.Item>
                    <Button className="button" onClick={connect}>Connect Wallet</Button>
                  </Nav.Item>
                </div>
            )}
          </Nav>
        </Container>
      </Navbar>
    <Router>
      <Routes>
        <Route path="/" element={<Main/>}/>
        <Route path="/game-list" element={<GameList/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/home" element={<Home/>}/>
      </Routes>
    </Router>
      <style>{`
        .grid{
          display: flex;
          justify-content: end;
        }
        .chainItem{
          margin-right: 10px;
        }
        .button {
          background: ${web3Provider ? 'red' : 'blue'};
          border: none;
          border-radius: 0.5rem;
          color: #fff;
        }
      `}</style>
    </div>
  )
}

export default App;
